const LOGOS = [
  "Helix Health", "Northbound", "Cobalt Labs", "Vantix", "Arcline AI", "Meridian One",
  "Orbital RCM", "Halcyon", "Brightforge", "Lumen Cargo", "Praxis Edu", "Strata BFSI",
];

export default function LogosStrip() {
  const items = [...LOGOS, ...LOGOS];
  return (
    <section data-testid="logos-strip" className="bg-white border-y border-slate-200">
      <div className="sozos-container py-12">
        <p className="text-center text-xs uppercase tracking-[0.24em] text-slate-500 mb-8">
          Trusted by revenue teams across IT, SaaS, AI, BFSI, Healthcare, Manufacturing & Logistics
        </p>
        <div className="overflow-hidden">
          <div className="marquee-track">
            {items.map((name, i) => (
              <div
                key={i}
                className="shrink-0 px-8 md:px-12 flex items-center gap-3"
              >
                <div className="w-2 h-2 rounded-full bg-[#1E40AF]" />
                <span className="font-display text-xl md:text-2xl text-[#0A1F44]/80 tracking-tight whitespace-nowrap">
                  {name}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
